import React, { useEffect, useState } from 'react';
import { Box, Paper, Typography, LinearProgress } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

export default function SequenceTransition() {
  const { linkId } = useParams();
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let mounted = true;
    const totalMs = 5000;
    const stepMs = 50;
    let elapsed = 0;

    const interval = setInterval(() => {
      elapsed += stepMs;
      const p = Math.min(100, Math.round((elapsed / totalMs) * 100));
      if (mounted) setProgress(p);
      if (elapsed >= totalMs) {
        clearInterval(interval);
        navigate(`/sequence/${linkId}`, { replace: true, state: { startNow: true } });
      }
    }, stepMs);
    return () => { mounted = false; clearInterval(interval); };
  }, [linkId, navigate]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', bgcolor: '#f0fff0', px: 2 }}>
      <Paper sx={{ p: 6, borderRadius: 4, textAlign: 'center', width: '100%', maxWidth: 640, boxShadow: '0 8px 32px rgba(79,195,247,0.12)' }}>
        <Typography variant="h4" fontWeight={900} color="#4fc3f7" mb={1}>Great job!</Typography>
        <Typography variant="h6" fontWeight={700} color="#81c784" mb={3}>Preparing the next passage…</Typography>
        <LinearProgress variant="determinate" value={progress} sx={{ height: 10, borderRadius: 2, mb: 2 }} />
        <Typography color="#666">You will be redirected automatically.</Typography>
      </Paper>
    </Box>
  );
}
